import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGeneratePublicKeyParams {
}

export interface IGeneratePublicKeyResult extends IResult {
  key: rsa.IRSAPublicKey;
  keyId: string;
}

export class GeneratePublicKeyRequest extends Request<IGeneratePublicKeyParams, IGeneratePublicKeyResult> {
  constructor(params: IGeneratePublicKeyParams = {}) {
    super('generatePublicKey', params);
  }
}
